import { UserAliasEntity } from '../entities';
import { authResource } from './Auth';
export const AccountAliasResource = authResource({
    path: '/accounts/:accountId/aliases/:userAliasId',
    schema: UserAliasEntity
}).extend((BaseResource) => ({
    confirm: BaseResource.update.extend({
        path: '/accounts/:accountId/aliases/:userAliasId/confirm/:code',
        method: 'POST',
        body: undefined,
        schema: undefined,
        process: (response) => {
            if (response !== 'Success') {
                throw new Error(response);
            }
            return undefined;
        }
    }),
    delete: BaseResource.delete.extend({
        schema: undefined,
        process: (response) => {
            if (!response || typeof response !== 'object' || response.status !== 1) {
                throw new Error(response);
            }
            return undefined;
        }
    }),
    resendConfirmation: BaseResource.update.extend({
        path: '/accounts/:accountId/aliases/:userAliasId/resendcode',
        method: 'POST',
        body: undefined,
        schema: undefined,
        process: (response) => {
            if (response !== 'Success') {
                throw new Error(response);
            }
            return undefined;
        }
    })
}));
